import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-prevoyance-professionnelle',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-professionnelle.component.html',
  styleUrls: ['./assurance-prevoyance-professionnelle.component.scss']
})
export class AssurancePrevoyanceProfessionnelleComponent {
  title = 'Assurance Prévoyance Professionnelle';
  subtitle = '';
  heroVideo = 'assets/videos/prevoyance.mp4';
  
  breadcrumbs =     [
    { label: 'Professionnels', link: undefined },
    { label: 'Assurance Prévoyance', link: undefined }
  ];



  prevPage = { 
    title: 'Assurance Mutuelle Santé Entreprise',
    link: '/assurance-collective-entreprise'
  };

  nextPage = { 
    title: 'Assurance Prévoyance Entreprise',
    link: '/assurance-prevoyance-entreprise'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' },
    { name: 'SPVIE', logo: 'assets/logos/SPIVE.PNG' },
    { name: 'HENNER', logo: 'assets/logos/HENNER.PNG' },
    { name: 'APIVIA', logo: 'assets/logos/APIVIA.PNG' }
  ];

  constructor(private router: Router) {}

  navigateToComparison() {
    this.router.navigate(['/cac/comparaison']);
  }
}
